module.exports = __webpack_public_path__ + "media/mypage/images/special/010-9f1bb7852882ea0b2be96b907bc60971.jpg";